<template>
  <div id="home-container" class="ps-20">
    <div id="jumbotron-container">
      <div class="container">
        <div class="row">
          <div class="col col-lg-7">
            <text-block content-id="jumbotronHeader" v-on:save="save" :content="content.elements.jumbotronHeader"/>
            <text-block content-id="jumbotronText" v-on:save="save" :content="content.elements.jumbotronText"/>
          </div>
        </div>
      </div>
    </div>
    <div id="section-links" class="section">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="row">
              <div class="col text-end">
                <text-block content-id="linksHeader1" v-on:save="save" :content="content.elements.linksHeader1"/>
                <text-block content-id="links1" v-on:save="save" :content="content.elements.links1"/>
              </div>
            </div>
          </div>
          <div class="col text-center">
            <img id="question-mark" src="@/assets/icon/icon_questionmark_large.svg" alt="question mark"/>
          </div>
          <div class="col">
            <div class="row">
              <div class="col-12">
                <text-block content-id="linksHeader2" v-on:save="save" :content="content.elements.linksHeader2"/>
                <text-block content-id="links2" v-on:save="save" :content="content.elements.links2"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="section-news" class="section">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <img class="w-100" src="@/assets/family.jpg" alt="family"/>
          </div>
          <div class="col-12 mt-4">
            <a class="news-headline" :href="t('CIRCULAR_ECONOMY_IN_ESTONIA_LINK')" target="_blank" rel="noopener noreferrer">{{ t("CIRCULAR_ECONOMY_IN_ESTONIA") }}</a>
          </div>
        </div>
      </div>
    </div>
    <div id="section-contacts" class="section">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="row">
              <div class="col">
                <div class="text24-black">{{ t("IMPORTANT_CONTACTS") }}</div>
              </div>
            </div>
            <div id="important-contacts" class="row mt-4 mb-n4">
              <div class="col-4 white-space" v-for="contact in contacts" :key="contact.title">
                <div class="row">
                  <div class="col-auto">
                    <img :src="contact.icon" alt="contact icon"/>
                  </div>
                  <div class="col">
                    <div class="row">
                      <div class="col">
                        <div class="title-blue">{{ contact.title }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div class="text16-black">{{ contact.description }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onBeforeUnmount, onMounted, ref} from "vue";
import {injectAxios} from "@/util/inject";
import {useI18n} from "vue-i18n";
import EventBus from "@/util/eventBus";
import {usePageContent} from "@/mixins/pageContentMixin2";
import TextBlock from "@/views/components/TextBlock.vue";
import doctorIcon from "@/assets/icon_doctor.svg";
import exclamationIcon from "@/assets/icon_exclamation.svg";
import conversationIcon from "@/assets/icon_conversation.svg";

const {getPageContent, savePageContent} = usePageContent();
const axios = injectAxios();
const {t, locale} = useI18n();
const content = ref({elements: {}});
const pageName = "home";

onMounted(() => {
  EventBus.$on("locale", loadPageContent);
  loadPageContent();
});

onBeforeUnmount(() => {
  EventBus.$off("locale", loadPageContent);
});

async function loadPageContent() {
  content.value = await getPageContent(axios, pageName, locale.value);
}

const save = (elem) => {
  savePageContent(axios, pageName, locale.value, elem.element, elem.value);
};
const contacts = computed(() => {
  return getContacts();
});

const getContacts = () => {
  return [
    {
      title: "1220",
      description: t("HOMEPAGE_IMPORTANT_CONTACTS.FAMILY_DOCTOR"),
      icon: doctorIcon,
    },
    {
      title: "1247",
      description: t("HOMEPAGE_IMPORTANT_CONTACTS.CRISIS_HOTLINE"),
      icon: exclamationIcon,
    },
    {
      title: "6123500",
      description: t("HOMEPAGE_IMPORTANT_CONTACTS.MIGRATION_CONSULTANT"),
      icon: conversationIcon,
    },
  ];
};
</script>
<style lang="scss" scoped>
#jumbotron-container {
  background:
    linear-gradient(270deg, rgba(0, 0, 150, 0.2) 0%, #000096 73.46%),
    url("@/assets/home_pic1.png") no-repeat 15vw 0;
  background-size: cover;
  padding-top: 240px;
  padding-bottom: 146px;
  padding-left: 20px;
  padding-right: 20px;
}

#btn-signup {
  padding: 16px;
  background-color: transparent;
}

#section-links {
  background-color: var(--p-color-blue-600);
}

#section-contacts {
  background-color: var(--p-color-yellow-100);
}

@media screen and (max-width: 768px) {
  #important-contacts {
    display: inline-flex;
    flex-direction: row !important;
  }
  #question-mark {
    height: 150px;
    width: 150px;
    margin-top: 50px;
    margin-bottom: 50px;
  }
  .row {
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .news-headline {
    font-size: 32px;
    line-height: 38px;
    color: var(--p-color-blue-600);
  }
  .white-space {
    white-space: pre-line;
    min-height: 410px;
    min-width: 150px;
    margin-bottom: 2rem;
  }
}

@media (min-width: 1400px) {
  #section-news {
    & > .container,
    & > .container-sm,
    & > .container-md,
    & > .container-lg,
    & > .container-xl {
      max-width: 1136px;
    }
  }
}
</style>
